var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquareRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-rght-box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.33333 10.5091L10.8426 7.99984M10.8426 7.99984L8.33333 5.49058M10.8426 7.99984H5.82407M5.69861 13.6457H10.9681C12.022 13.6457 12.549 13.6457 12.9516 13.4406C13.3057 13.2601 13.5936 12.9722 13.774 12.6181C13.9792 12.2155 13.9792 11.6885 13.9792 10.6346V5.36512C13.9792 4.31113 13.9792 3.78413 13.774 3.38156C13.5936 3.02745 13.3057 2.73955 12.9516 2.55912C12.549 2.354 12.022 2.354 10.9681 2.354H5.69861C4.64462 2.354 4.11763 2.354 3.71506 2.55912C3.36095 2.73955 3.07305 3.02745 2.89262 3.38156C2.6875 3.78413 2.6875 4.31113 2.6875 5.36511V10.6346C2.6875 11.6885 2.6875 12.2155 2.89262 12.6181C3.07305 12.9722 3.36095 13.2601 3.71506 13.4406C4.11763 13.6457 4.64462 13.6457 5.69861 13.6457Z",
    stroke: "url(#paint0_linear_1575_95)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1575_95",
    x1: 1.85822,
    y1: 2.354,
    x2: 13.9792,
    y2: 13.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareRight);
export default __webpack_public_path__ + "static/media/icon_square_right.4457dee5218ababcf760d9bede55c6fc.svg";
export { ForwardRef as ReactComponent };